function baseProps(props) {
  return {
    viewBox: '0 0 24 24',
    width: 18,
    height: 18,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    ...props,
  };
}

export function IconPlus(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </svg>
  );
}

export function IconEdit(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />
    </svg>
  );
}

export function IconTrash(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M3 6h18" />
      <path d="M8 6V4h8v2" />
      <path d="M19 6l-1 14H6L5 6" />
      <path d="M10 11v6" />
      <path d="M14 11v6" />
    </svg>
  );
}

export function IconUsers(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function IconGlobe(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z" />
      <path d="M2 12h20" />
      <path d="M12 2a15 15 0 0 1 0 20" />
      <path d="M12 2a15 15 0 0 0 0 20" />
    </svg>
  );
}

export function IconShield(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
    </svg>
  );
}

export function IconAlertTriangle(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M10.3 3.3 1.6 18a2 2 0 0 0 1.7 3h17.4a2 2 0 0 0 1.7-3L13.7 3.3a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </svg>
  );
}

export function IconClose(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M18 6 6 18" />
      <path d="M6 6l12 12" />
    </svg>
  );
}

export function IconMenu(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 6h16" />
      <path d="M4 12h16" />
      <path d="M4 18h16" />
    </svg>
  );
}

export function IconDashboard(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M3 13a9 9 0 1 1 18 0" />
      <path d="M12 13l4-4" />
      <path d="M12 21v-8" />
    </svg>
  );
}

export function IconChart(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M3 3v18h18" />
      <path d="M7 14l3-3 4 4 6-7" />
    </svg>
  );
}

export function IconCode(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M8 8 4 12l4 4" />
      <path d="M16 8l4 4-4 4" />
      <path d="M14 4 10 20" />
    </svg>
  );
}

export function IconFileText(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
      <path d="M10 9H8" />
    </svg>
  );
}

export function IconLayers(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 2 2 7l10 5 10-5-10-5Z" />
      <path d="M2 12l10 5 10-5" />
      <path d="M2 17l10 5 10-5" />
    </svg>
  );
}

export function IconImage(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <circle cx="9" cy="10" r="1.4" />
      <path d="M21 16l-5.5-5.5a1.6 1.6 0 0 0-2.3 0L7 16" />
      <path d="M14 14l1.5-1.5a1.6 1.6 0 0 1 2.3 0L21 15.2" />
    </svg>
  );
}

export function IconDroplet(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 2s7 7 7 13a7 7 0 0 1-14 0c0-6 7-13 7-13Z" />
    </svg>
  );
}

export function IconBan(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M5.5 5.5 18.5 18.5" />
    </svg>
  );
}

export function IconLayoutGrid(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="3" y="3" width="8" height="8" rx="2" />
      <rect x="13" y="3" width="8" height="8" rx="2" />
      <rect x="3" y="13" width="8" height="8" rx="2" />
      <rect x="13" y="13" width="8" height="8" rx="2" />
    </svg>
  );
}

export function IconType(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 6h16" />
      <path d="M10 6v14" />
      <path d="M14 6v14" />
    </svg>
  );
}

export function IconCards(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="4" y="5" width="16" height="6" rx="2" />
      <rect x="4" y="13" width="10" height="6" rx="2" />
      <path d="M16 13h4v6h-4z" />
    </svg>
  );
}

export function IconUtensils(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 3v5" />
      <path d="M6 3v5" />
      <path d="M8 3v5" />
      <path d="M6 8v13" />
      <path d="M16 3v18" />
      <path d="M16 3c2 1.8 3 4.2 3 7" />
    </svg>
  );
}

export function IconCarousel(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="6" y="7" width="12" height="10" rx="2" />
      <path d="M3 12h1" />
      <path d="M20 12h1" />
      <path d="M8 5h8" />
      <path d="M8 19h8" />
    </svg>
  );
}

export function IconSparkles(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 2l1.4 4.6L18 8l-4.6 1.4L12 14l-1.4-4.6L6 8l4.6-1.4L12 2Z" />
      <path d="M4 12l.9 2.8L8 16l-3.1 1.2L4 20l-.9-2.8L0 16l3.1-1.2L4 12Z" />
    </svg>
  );
}

export function IconAlignLeft(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 6h16" />
      <path d="M4 10h10" />
      <path d="M4 14h16" />
      <path d="M4 18h10" />
    </svg>
  );
}

export function IconAlignCenter(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 6h16" />
      <path d="M7 10h10" />
      <path d="M4 14h16" />
      <path d="M7 18h10" />
    </svg>
  );
}

export function IconAlignRight(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 6h16" />
      <path d="M10 10h10" />
      <path d="M4 14h16" />
      <path d="M10 18h10" />
    </svg>
  );
}

export function IconTag(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M20.6 13.6 13.6 20.6a2 2 0 0 1-2.8 0L3 12.8V3h9.8l7.8 7.8a2 2 0 0 1 0 2.8Z" />
      <path d="M7.5 7.5h.01" />
    </svg>
  );
}

export function IconVideo(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="3" y="7" width="14" height="10" rx="2" />
      <path d="M17 10l4-2v8l-4-2v-4Z" />
    </svg>
  );
}

export function IconMusic(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M9 18V6l12-2v12" />
      <circle cx="7.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="16.5" r="2.5" />
    </svg>
  );
}

export function IconDownload(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 3v10" />
      <path d="M8 11l4 4 4-4" />
      <path d="M4 21h16" />
    </svg>
  );
}

export function IconChevronDown(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  );
}

export function IconChevronRight(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

export function IconPin(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 17v5" />
      <path d="M6 8l6-6 6 6" />
      <path d="M9 8v6l-2 2v1h10v-1l-2-2V8" />
    </svg>
  );
}

export function IconEyeOff(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M3 3l18 18" />
      <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
      <path d="M9.9 5.1A10.5 10.5 0 0 1 12 5c5 0 9.3 3.1 11 7-0.6 1.4-1.5 2.6-2.6 3.7" />
      <path d="M6.2 6.2C4.2 7.4 2.7 9.1 1.9 12c1.7 3.9 6 7 10.1 7 1.2 0 2.4-.2 3.5-.5" />
    </svg>
  );
}

export function IconTable(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 10h18" />
      <path d="M3 14h18" />
      <path d="M9 5v14" />
      <path d="M15 5v14" />
    </svg>
  );
}

export function IconLink(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7 7l-1 1" />
      <path d="M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 0 1-7-7l1-1" />
    </svg>
  );
}

export function IconExternalLink(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M14 3h7v7" />
      <path d="M10 14 21 3" />
      <path d="M21 14v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6" />
    </svg>
  );
}

export function IconSearch(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.2-3.2" />
    </svg>
  );
}

export function IconKey(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <circle cx="7.5" cy="14.5" r="3.5" />
      <path d="M11 14.5h10" />
      <path d="M18 14.5v3" />
      <path d="M15 14.5v2" />
    </svg>
  );
}

export function IconKeyboard(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="3" y="7" width="18" height="10" rx="2" />
      <path d="M7 10h0.01" />
      <path d="M10 10h0.01" />
      <path d="M13 10h0.01" />
      <path d="M16 10h0.01" />
      <path d="M7 13h0.01" />
      <path d="M10 13h0.01" />
      <path d="M13 13h0.01" />
      <path d="M16 13h0.01" />
      <path d="M8 15h8" />
    </svg>
  );
}

export function IconClock(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

export function IconCheck(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

export function IconCopy(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}

export function IconFlag(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M4 22V4" />
      <path d="M4 15s1-1 4-1 4 2 8 2 4-1 4-1V3s-1 1-4 1-4-2-8-2-4 1-4 1Z" />
    </svg>
  );
}

export function IconMoreVertical(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M12 5h.01" />
      <path d="M12 12h.01" />
      <path d="M12 19h.01" />
    </svg>
  );
}

export function IconFolder(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
    </svg>
  );
}

export function IconDatabase(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <ellipse cx="12" cy="5" rx="7" ry="3" />
      <path d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5" />
      <path d="M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6" />
    </svg>
  );
}

export function IconAccessibility(props) {
  return (
    <svg {...baseProps(props)} aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="7" r="1.5" />
      <path d="M7 9.5c1.7 1 3.5 1.5 5 1.5s3.3-.5 5-1.5" />
      <path d="M12 11v9" />
      <path d="M9 20l1.8-5" />
      <path d="M15 20l-1.8-5" />
    </svg>
  );
}
